import podsButtons  from './tab-buttons/pods' 
import clientiButtons from './tab-buttons/clienti'
import fattureVendita from './tab-buttons/fatture-vendita'
// import fattureAcquisto from './tab-buttons/fatture-acquisto'
import listiniButtons from './tab-buttons/listini'
import rappresentantiButtons from './tab-buttons/rappresentanti'
import pdrsButtons from './tab-buttons/pdrs'
import contrattiVenditaButtons from './tab-buttons/contratti-vendita'
// import fornitoriButtons from './tab-buttons/fornitori'
import agentiButtons from './tab-buttons/agenti'

export default [
  {
    label: 'CLIENTI',
    icon: 'pi pi-user',
    component: 'ClientiDataTable',
    name: 'clientiDataTable',
    default: true,
    buttons: clientiButtons
  },
  {
    label: 'FATTURE VENDITA',
    icon: 'pi pi-copy',
    component: 'FattureClientiDataTable',
    name: 'fattureClientiDataTable',
    default: true,
    buttons: fattureVendita
  },
  // {
  //   label: 'FATTURE ACQUISTO',
  //   icon: 'pi pi-shopping-cart',
  //   component: 'FattureAcquistoDataTable',
  //   name: 'fattureAcquistoDataTable',
  //   default: true,
  //   buttons: fattureAcquisto
  // },
  // {
  //   label: 'FORNITORI',
  //   icon: 'pi pi-wallet',
  //   component: 'FornitoriDataTable',
  //   name: 'fornitoriDataTable',
  //   default: true,
  //   buttons: fornitoriButtons
  // },
  {
    label: 'CONTRATTI VENDITA',
    icon: 'pi pi-copy',
    component: 'ContrattiVenditaDataTable',
    name: 'contrattiVenditaDataTable',
    default: true,
    buttons: contrattiVenditaButtons
  },
  {
    label: 'LISTINI',
    icon: 'pi pi-copy',
    component: 'ListiniDataTable',
    name: 'listiniDataTable',
    default: true,
    buttons: listiniButtons
  },
  {
    label: 'PODS',
    icon: 'fas fa-lightbulb',
    component: 'PodsDataTable',
    name: 'podsDataTable',
    default: true,
    buttons: podsButtons
  },
  {
    label: 'PDRS',
    icon: 'fas fa-fire',
    component: 'PdrsDataTable',
    name: 'pdrsDataTable',
    default: true,
    buttons: pdrsButtons
  },
  {
    label: 'RAPPRESENTANTI',
    icon: 'pi pi-user',
    component: 'RappresentantiDataTable',
    name: 'rappresentantiDataTable',
    default: true,
    buttons: rappresentantiButtons
  },
  {
    label: 'AGENTI',
    icon: 'pi pi-users',
    component: 'AgentiDataTable',
    name: 'agentiDataTable',
    default: true,
    buttons: agentiButtons
  },
  {
    label: 'AGENTI FIRMATARI',
    icon: 'pi pi-users',
    component: 'AgentiFirmatariDataTable',
    name: 'agentiFirmatariDataTable',
    default: true,
    buttons: agentiButtons
  },
]
